<mat-accordion class="vendor-filter-accordion custom-expansion-theme">
    <mat-expansion-panel [expanded]="filterPanelExpanded()">
        @if (mode() === CHATBOT_MODE_MARKET_SCAN) {
            <mat-expansion-panel-header>
                <div class="vendor-filter-header">
                    <div class="vendor-summary">
                        @for (v of allVendors(); track v.code) {
                            @if (v.code === vendor()) {
                                <img [src]="v.image_base64" [alt]="v.code" class="vendor-logo" />
                                <div class="vendor-details">
                                    <strong>{{ v.name }}</strong>
                                    <span>{{ v.description }}</span>
                                </div>
                            }
                        }
                    </div>
                    <div class="filter-summary">
                        <span class="description"> Refine your search <mat-icon>filter_alt</mat-icon> </span>
                    </div>
                </div>
            </mat-expansion-panel-header>
        } @else {
            <mat-expansion-panel-header>
                <mat-panel-title>Filters</mat-panel-title>
                <mat-panel-description>
                    Refine your search
                    <mat-icon>filter_alt</mat-icon>
                </mat-panel-description>
            </mat-expansion-panel-header>
        }
        @if (formReady()) {
            <div class="sphere-filter-panel" [formGroup]="filterForm">
                <!-- Date Range Section -->
                <div class="date-range-section">
                    <div class="date-controls">
                        <mat-form-field appearance="outline">
                            <mat-label>Date Range</mat-label>
                            <mat-date-range-input [formGroup]="filterForm.get('dateRange')" [rangePicker]="picker">
                                <input matStartDate formControlName="startDate" placeholder="Start date" />
                                <input matEndDate formControlName="endDate" placeholder="End date" />
                            </mat-date-range-input>
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-date-range-picker #picker (closed)="forceRangePickerValues()"></mat-date-range-picker>
                        </mat-form-field>
                    </div>
                </div>
                <mat-divider></mat-divider>
                <!-- Toggles Section -->
                <div class="toggles-section">
                    <h3 class="section-title">News Feeds</h3>
                    <sphere-filter-panel
                        [style.width.%]="20"
                        [filterControl]="feedSearchControl"
                        placeholder="Search feeds..."
                        filterIcon="search"
                    ></sphere-filter-panel>
                    @if (filteredToggleOptions().length > 0) {
                        <div class="toggle-grid">
                            @for (toggle of filteredToggleOptions(); track toggle.code) {
                                <div
                                    class="toggle-card"
                                    [class.disabled]="!toggle.has_access"
                                    [matTooltip]="!toggle.has_access ? 'No permissions for this feed. Please contact your system administrator' : ''"
                                >
                                    <div class="toggle-card-content">
                                        <div class="toggle-info">
                                            <span class="toggle-label">{{ toggle.description }}</span>
                                            @if (!toggle.has_access) {
                                                <mat-icon class="lock-icon">lock</mat-icon>
                                            }
                                        </div>
                                        <mat-slide-toggle color="primary" class="slide-toggle" [formControlName]="toggle.code"> </mat-slide-toggle>
                                    </div>
                                </div>
                            }
                        </div>
                    } @else {
                        <sphere-no-matches [ifCondition]="false" notFoundText="No feeds found"></sphere-no-matches>
                    }
                </div>

                <!-- Reset Button -->
                <div class="actions">
                    <button mat-button color="primary" (click)="resetFilters()">Reset filters</button>
                </div>
            </div>
        } @else if (areVendorSourcesLoading()) {
            <!-- Loading -->
            <div class="filters__loading">
                <mat-spinner [diameter]="90" [strokeWidth]="8"></mat-spinner>
                <h2>Loading feeds</h2>
            </div>
        } @else if (vendorSourcesError()?.error) {
            <!-- Error -->
            <h2>
                Error loading feeds.
                {{ vendorSourcesError()?.status }} - {{ vendorSourcesError()?.statusText || vendorSourcesError()?.message }}
            </h2>
        }
    </mat-expansion-panel>
</mat-accordion>
